import { AddOutlined, CancelOutlined, DeleteOutlineOutlined, ToggleOff, ToggleOn } from "@mui/icons-material";
import { Box } from "@mui/material";
import { styled, darken, alpha, lighten } from "@mui/material/styles";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const getBackgroundColor = (color, mode, opacity) => {
  return mode === "dark" ? darken(color, opacity) : lighten(color, opacity);
};

const SyledGrid = styled(DataGrid)(({ theme }) => ({
  border: "1px solid #9ebeeb",

  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "lavender",
    borderLeft: "1px solid #9ebeeb",
    "& .MuiSvgIcon-root": {
      borderColor: "#97b8d8",
    },
  },
  "& .MuiDataGrid-cell": {
    borderLeft: "1px solid #9ebeeb",
    borderBottom: "1px solid #9ebeeb",
    "& .MuiSvgIcon-root": {
      borderColor: "#97b8d8",
    },
  },
  ".custom-editable-header": {
    backgroundColor: "#1A73E8 !important",
    color: "#fff",
    fontWeight: "bold",
    whiteSpace: "normal !important",
  },
  "& .status--O": {
    backgroundColor: "lightcyan",
  },
  "& .status--R": {
    backgroundColor: getBackgroundColor(theme.palette.success.main, theme.palette.mode, 0.7),
    "&:hover": {
      backgroundColor: getBackgroundColor(theme.palette.success.main, theme.palette.mode, 0.6),
    },
    "&.Mui-selected": {
      backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.7),
      "&:hover": {
        backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.6),
      },
    },
  },
  "& .status--C": {
    backgroundColor: "lightyellow",
  },
  "& .status--I": {
    backgroundColor: getBackgroundColor(theme.palette.secondary.main, theme.palette.mode, 0.7),
    "&:hover": {
      backgroundColor: getBackgroundColor(theme.palette.secondary.main, theme.palette.mode, 0.6),
    },
    "&.Mui-selected": {
      backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.7),
      "&:hover": {
        backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.6),
      },
    },
  },
}));

const StatusGrid = styled(DataGrid)(({ theme }) => ({
  ".custom-editable-header": {
    backgroundColor: "#1A73E8 !important",
    color: "#fff",
    fontWeight: "bold",
    whiteSpace: "normal !important",
  },
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "lavender",
    borderLeft: "1px solid #9ebeeb",
    "& .MuiSvgIcon-root": {
      borderColor: "#97b8d8",
    },
  },
  "& .MuiDataGrid-cell": {
    borderLeft: "1px solid #9ebeeb",
    borderBottom: "1px solid #9ebeeb",
    "& .MuiSvgIcon-root": {
      borderColor: "#97b8d8",
    },
  },
  "& .status--O": {
    backgroundColor: "honeydew",
  },
  "& .status--A": {
    backgroundColor: "lightcyan",
  },
  "& .status--R": {
    backgroundColor: getBackgroundColor(theme.palette.success.main, theme.palette.mode, 0.7),
    "&:hover": {
      backgroundColor: getBackgroundColor(theme.palette.success.main, theme.palette.mode, 0.6),
    },
    "&.Mui-selected": {
      backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.7),
      "&:hover": {
        backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.6),
      },
    },
  },
  "& .status--C": {
    backgroundColor: "lightyellow",
  },
  "& .status--I": {
    backgroundColor: getBackgroundColor(theme.palette.secondary.main, theme.palette.mode, 0.7),
    "&:hover": {
      backgroundColor: getBackgroundColor(theme.palette.secondary.main, theme.palette.mode, 0.6),
    },
    "&.Mui-selected": {
      backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.7),
      "&:hover": {
        backgroundColor: getBackgroundColor(theme.palette.primary.main, theme.palette.mode, 0.6),
      },
    },
  },
  "& .status--U":{
    backgroundColor:"lavenderblush"
  }
}));

const StripedGrid = styled(DataGrid)(({ theme }) => ({
  border: "1px solid #9ebeeb",

  ".custom-editable-header": {
    backgroundColor: "#1A73E8 !important",
    color: "#fff",
    fontWeight: "bold",
    whiteSpace: "normal !important",
  },

  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "lavender",
    borderLeft: "1px solid #9ebeeb",
    "& .MuiSvgIcon-root": {
      borderColor: "#97b8d8",
    },
  },
  "& .MuiDataGrid-cell": {
    borderLeft: "1px solid #9ebeeb",
    borderBottom: "1px solid #9ebeeb",
    "& .MuiSvgIcon-root": {
      borderColor: "#97b8d8",
    },
  },

  "& .even": {
    //backgroundColor: theme.palette.grey[200],
    backgroundColor: "transparent",
    "&:hover, &.Mui-hovered": {
      //   backgroundColor: alpha(theme.palette.info.main, 0.2),
      "@media (hover:none)": {
        backgroundColor: "transparent",
      },
    },
  },
  "& .odd": {
    backgroundColor: "#e8eff9",
    "&:hover, &.Mui-hovered": {
      //backgroundColor: alpha(theme.palette.primary.main, 0.2),
      backgroundColor: "#ceddf2",
      // "& .MuiDataGrid-cell": { borderLeft: "1px solid #84aee9" },
      "@media (hover:none)": {
        backgroundColor: "transparent",
      },
    },
    // "&.Mui-selected": {
    //   backgroundColor: alpha(
    //     theme.palette.primary.main,
    //     0.2
    //   ),
    //   "&:hover, &.Mui-hovered": {
    //     backgroundColor: alpha(theme.palette.primary.main, 0.2 + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    //     "@media (hover:none)": {
    //       backgroundColor: alpha(
    //         theme.palette.primary.main,
    //         0.2 + theme.palette.action.selectedOpacity
    //       ),
    //     },
    //   },
    // },
  },

  "&.Mui-selected": {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    "&:hover, &.Mui-hovered": {
      backgroundColor: alpha(
        theme.palette.primary.main,
        0.2 + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
      ),
      "@media (hover:none)": {
        backgroundColor: alpha(theme.palette.info.main, 0.2 + theme.palette.action.selectedOpacity),
      },
    },
  },
}));

function StyledDataGrid({ ...data }) {
  return (
    <SyledGrid
      autoHeight
      showCellVerticalBorder
      showColumnVerticalBorder
      {...data}
      disableColumnMenu={true}
    />
  );
}

function StripedDataGrid({ ...data }) {
  return (
    <StripedGrid
      autoHeight
      showCellVerticalBorder
      showColumnVerticalBorder
      {...data}
      disableColumnMenu={true}
      getRowClassName={(params) => {
        return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
      }}
    />
  );
}

function StatusDataGrid({ ...data }) {
  return (
    <StatusGrid
      autoHeight
      showCellVerticalBorder
      showColumnVerticalBorder
      disableColumnMenu={true}
      disableRowSelectionOnClick={true}
      isCellEditable={(params) => params.row.status !== "C"}
      getRowClassName={(params) => {
        return `status--${params.row.status}`;
      }}
      {...data}
    />
  );
}

function StripedCheckboxDataGrid({ ...data }) {
  return (
    <StripedGrid
      autoHeight
      showCellVerticalBorder
      showColumnVerticalBorder
      {...data}
      disableColumnMenu={true}
      checkboxSelection={true}
      disableRowSelectionOnClick={true}
      getRowClassName={(params) => {
        return params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd";
      }}
    />
  );
}

const DataGridLabel = () => (
  <MDBox display="flex" alignItems="center">
    <MDTypography pb={1} color="info" variant="h5" mr="2rem">
      Datagrid Display
    </MDTypography>
    <MDTypography pb={1} color="secondary" variant="h6" mr="2rem">
      Row Status:
    </MDTypography>
    <MDTypography pb={1} color="info" variant="h6" mr="2rem">
      Open
    </MDTypography>
    <MDTypography pb={1} color="warning" variant="h6" mr="2rem">
      Cancelled
    </MDTypography>
    <MDTypography pb={1} color="primary" variant="h6">
      Selected
    </MDTypography>
  </MDBox>
);

const CancelAction = ({ onClick, disabled }) => (
  <GridActionsCellItem
    icon={<CancelOutlined />}
    title="cancel"
    disabled={disabled}
    color="error"
    label="cancel"
    onClick={onClick}
  />
);

const AddAction = ({ onClick, disabled }) => (
  <GridActionsCellItem
    icon={<AddOutlined />}
    title="add"
    disabled={disabled}
    color="info"
    label="add"
    onClick={onClick}
  />
);

const DelAction = ({ onClick }) => (
  <GridActionsCellItem
    icon={<DeleteOutlineOutlined />}
    title="delete"
    color="error"
    label="delete"
    onClick={onClick}
  />
);

const ActivateAction = ({ onClick }) => (
  <GridActionsCellItem
    icon={<ToggleOn />}
    title="activate"
    color="success"
    label="activate"
    onClick={onClick}
  />
);

const DeactivateAction = ({ onClick }) => (
  <GridActionsCellItem
    icon={<ToggleOff />}
    title="deactivate"
    color="error"
    label="deactivate"
    onClick={onClick}
  />
);

export {
  StyledDataGrid,
  StripedDataGrid,
  StripedCheckboxDataGrid,
  StatusDataGrid,
  CancelAction,
  AddAction,
  DelAction,
  ActivateAction,
  DeactivateAction,
  DataGridLabel,
};
